/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `critical` - Critical
 * * `high` - High
 * * `medium` - Medium
 * * `low` - Low
 * * `info` - Informational
 * @export
 */
export const BrandInfringementSeverityEnum = {
    Critical: 'critical',
    High: 'high',
    Medium: 'medium',
    Low: 'low',
    Info: 'info'
} as const;
export type BrandInfringementSeverityEnum = typeof BrandInfringementSeverityEnum[keyof typeof BrandInfringementSeverityEnum];


export function instanceOfBrandInfringementSeverityEnum(value: any): boolean {
    for (const key in BrandInfringementSeverityEnum) {
        if (Object.prototype.hasOwnProperty.call(BrandInfringementSeverityEnum, key)) {
            if (BrandInfringementSeverityEnum[key as keyof typeof BrandInfringementSeverityEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BrandInfringementSeverityEnumFromJSON(json: any): BrandInfringementSeverityEnum {
    return BrandInfringementSeverityEnumFromJSONTyped(json, false);
}

export function BrandInfringementSeverityEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandInfringementSeverityEnum {
    return json as BrandInfringementSeverityEnum;
}

export function BrandInfringementSeverityEnumToJSON(value?: BrandInfringementSeverityEnum | null): any {
    return value as any;
}

export function BrandInfringementSeverityEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): BrandInfringementSeverityEnum {
    return value as BrandInfringementSeverityEnum;
}

